module.exports = __webpack_public_path__ + "img/signature.913c338.webp";